import React from "react";
import { cn } from "@/lib/utils";

// Eight compliance modules shown as filter tabs on the client profile view.
// Existing task data uses only two category values ("Tax", "Secretarial") —
// they map to Income Tax and Companies Act respectively. The remaining
// modules render with a zero count until tasks are tagged with them.
export const MODULES = [
  { key: "income-tax", label: "Income Tax", categories: ["Tax"] },
  { key: "gst", label: "GST", categories: ["GST"] },
  { key: "companies-act", label: "Companies Act", categories: ["Secretarial"] },
  { key: "fema", label: "FEMA", categories: ["FEMA"] },
  { key: "fcra", label: "FCRA", categories: ["FCRA"] },
  { key: "labour", label: "Labour", categories: ["Labour"] },
  { key: "sebi", label: "SEBI", categories: ["SEBI"] },
  { key: "rbi", label: "RBI", categories: ["RBI"] },
];

export const MODULE_KEYS = MODULES.map((m) => m.key);

// Return true if a task belongs to the given module key.
export function taskInModule(task, moduleKey) {
  const mod = MODULES.find((m) => m.key === moduleKey);
  if (!mod) return false;
  return mod.categories.includes(task.category);
}

function Tab({ label, count, active, onClick, testId }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className={cn(
        "relative shrink-0 px-3.5 py-2 text-sm font-medium rounded-lg transition-colors inline-flex items-center gap-2",
        active
          ? "bg-white text-[#0F172A] border border-[#E2E8F0] shadow-sm"
          : "text-[#64748B] hover:text-[#0F172A]"
      )}
    >
      <span>{label}</span>
      <span
        className={cn(
          "text-[11px] font-medium rounded px-1.5 py-0.5 tabular-nums",
          active
            ? "bg-[#F1F5F9] text-[#0F172A]"
            : "bg-transparent text-[#94A3B8]"
        )}
      >
        {count}
      </span>
    </button>
  );
}

export default function CategoryTabs({ tab, onChange, counts }) {
  return (
    <div
      className="inline-flex max-w-full overflow-x-auto items-center gap-1 p-1 bg-[#F1F5F9] rounded-xl [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
      role="tablist"
      aria-label="Compliance module"
      data-testid="category-tabs"
    >
      {MODULES.map((m) => (
        <Tab
          key={m.key}
          label={m.label}
          count={counts?.[m.key] ?? 0}
          active={tab === m.key}
          onClick={() => onChange(m.key)}
          testId={`tab-${m.key}`}
        />
      ))}
    </div>
  );
}
